import { UI, HStack, VStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { ISkeletonProps, Skeleton } from 'native-base';
import React from 'react';

export interface ILoadingTableProps {
  items?: number;
  columnsWidths?: Record<string, number>;
  isMobile?: boolean;
}

export const ColoredSkeleton = (props: ISkeletonProps) => (
  <Skeleton {...props} endColor={Color['brand.primary.lightest']} />
);

export const LoadingTable: React.FC<ILoadingTableProps> = ({
  items = 6,
  columnsWidths = { c1: 100 },
  isMobile = false,
}) => {
  if (isMobile) {
    return (
      <VStack space={Spacing['stack.xxs']} py={Spacing['stack.xxxs']}>
        {Array.from({ length: items }).map((_, n) => (
          <UI.Shadow key={n} testId="shadow" level={1} borderRadius="8px">
            <VStack p={Spacing['inset.xs']} space={Spacing['stack.xxxs']}>
              {Array.from({ length: Object.keys(columnsWidths).length }).map((__, m) => (
                <HStack key={m.toString()} justifyContent="space-between">
                  <ColoredSkeleton w="2/5" h="18px" rounded={'full'} />
                  <ColoredSkeleton w="2/5" h="18px" rounded={'full'} />
                </HStack>
              ))}
            </VStack>
          </UI.Shadow>
        ))}
      </VStack>
    );
  }

  return (
    <VStack space={Spacing['stack.xxs']} py={Spacing['stack.xxxs']}>
      {Array.from({ length: items }).map((_, n) => (
        <UI.Shadow key={n} testId="shadow" level={1} borderRadius="8px">
          <HStack p={Spacing['inset.xs']}>
            {Object.keys(columnsWidths).map((key, m) => (
              <HStack key={m.toString()} w={`${columnsWidths[key]}%`}>
                <ColoredSkeleton w="4/6" h="14px" rounded={'full'} />
              </HStack>
            ))}
          </HStack>
        </UI.Shadow>
      ))}
    </VStack>
  );
};
